export const Color = {
  Primary: "#009688",
  PrimaryDark: "#00695C",
  Secondary: "#2196F3",
  SecondaryDark: "#1565C0",
  Attention: "#E91E63",
  AttentionDark: "#AD1457",
  AttentionLight: "#FBEDF3",
  Black: "#212121",
  Gray: "#616161",
  LightGray: "#9E9E9E",
  BorderGray: "#EBEBEB",
  BackgroundGray: "#f7f7f7",
  BackgroundPrimary: "#EBF7F5",
  BackgroundSecondary: "#EDF7FE",
  BackgroundAttention: "#FEF1F9",
  White: "#FFFFFF",
  Line: "#00C300",
  LpPrimary: "#5555FF",
  LpPrimaryDark: "#3636AA",
} as const

export const OverlayColor = {
  DeepBlack: "rgba(0,0,0,0.6)",
  ShallowBlack: "rgba(0,0,0,0.4)",
} as const

export const Shadow = {
  Shallow: "box-shadow: 0 1px 6px rgba(33,33,33,0.2)",
  Deep: `box-shadow: 0 2px 12px rgba(33,33,33,0.2)`,
} as const

export const IsMobile: Function = (css: any) => `
  @media screen and (max-width: 768px) {
    ${css}
  }
`

export const IsPC: Function = (css: any) => `
  @media screen and (min-width: 769px) {
    ${css}
  }
`

// NOTE: 以下の_から始まるpropertyは.演算子で参照できるようにするため

export const TextSize = {
  _2XS: 10,
  XS: 12,
  S: 14,
  M: 16,
  L: 20,
  XL: 24,
  _2XL: 28,
  _3XL: 32,
  _4XL: 36,

  /** @deprecated `TextSize._2XS`と書く */
  "2XS": 10,
  /** @deprecated `TextSize._2XL`と書く */
  "2XL": 28,
  /** @deprecated `TextSize._3XL`と書く */
  "3XL": 32,
  /** @deprecated `TextSize._4XL`と書く */
  "4XL": 36,
} as const

export const LineHeight = {
  _2XS: 100,
  XS: 120,
  S: 140,
  M: 160,
  L: 180,
  XL: 200,

  /** @deprecated `LineHeight._2XS`と書く */
  "2XS": 100,
} as const

export const SpacingSize = {
  _4XS: 2,
  _3XS: 4,
  _2XS: 6,
  XS: 8,
  S: 12,
  M: 16,
  L: 20,
  XL: 24,
  _2XL: 32,
  _3XL: 40,
  _4XL: 48,
  _5XL: 56,
  _6XL: 64,

  /** @deprecated `SpacingSize._4XS`と書く */
  "4XS": 2,
  /** @deprecated `SpacingSize._3XS`と書く */
  "3XS": 4,
  /** @deprecated `SpacingSize._2XS`と書く */
  "2XS": 6,
  /** @deprecated `SpacingSize._2XL`と書く */
  "2XL": 32,
  /** @deprecated `SpacingSize._3XL`と書く */
  "3XL": 40,
  /** @deprecated `SpacingSize._4XL`と書く */
  "4XL": 48,
  /** @deprecated `SpacingSize._5XL`と書く */
  "5XL": 56,
  /** @deprecated `SpacingSize._6XL`と書く */
  "6XL": 64,
} as const

export const Transparent: object = {
  Level1: 8,
  Level2: 12,
  Level3: 24,
  Level4: 32,
  Level5: 48,
  Level6: 60,
} as const

export const RadiusSize = {
  Small: 4,
  Medium: 8,
  Large: 16,
} as const

export const Transition = {
  Hover: "transition: 0.2s",
} as const

export enum Z {
  Child = 1,
  Tab,
  Fixed,
  Header,
  Popup,
  Overlay,
  Drawer,
  Modal,
}
